import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import './style.scss';
import { identity } from "../../utils/getIdentity";
import Button from "../Button";
import { connect } from "react-redux";
import { getAddressBookList, createAddressBook, deleteAddressBook, changeAddressBook } from "../../redux/actions/transactions";
import AddressBookList from "./AddressBookList";
import AddAddressModal from "./AddAddressModal";
import ReactPaginate from 'react-paginate';
import { Input } from "antd";
import resetCpayIcon from "../../img/cpay-svg/reset.svg";
import resetNfgIcon from "../../img/nfgpay-svg/reset-nfg.svg";
import resetFinvaroIcon from "../../img/finvaro/reset-finvaro.svg";
import resetClarniumIcon from "../../img/clarnium/reset-clarnium.svg";
import resetInexIcon from "../../img/inex/reset-inex.svg";
import resetInstaIcon from "../../img/instaXchange/reset-insta.svg";
import resetCoineraIcon from "../../img/coinera/reset-coinera.svg";

const resetIcon = {
  cpay: resetCpayIcon,
  nfg: resetNfgIcon,
  finvaro: resetFinvaroIcon,
  clarnium: resetClarniumIcon,
  inex: resetInexIcon,
  insta: resetInstaIcon,
  coinera: resetCoineraIcon
}

const AddressBookWrapper = ({
  getAddressBookList,
  addressBook,
  typeNetwork,
  currencies,
  createAddressBook,
  deleteAddressBook,
  changeAddressBook,
  notificationsChangeError
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState("");
  const [user, setUser] = useState(null);

  const addressBookList = (selectedPage, search = '') => {
    const pageNumber = selectedPage?.selected + 1;
    getAddressBookList({ page: pageNumber || 1, search: search.trim() || '', typeNetwork });
  };

  const resetSearch = () => {
    setSearch('');
    addressBookList();
  };

  useEffect(() => {
    addressBookList();
  }, [typeNetwork]);

  useEffect(() => {
    if (user) {
      setIsOpenModal(true);
    }
  }, [user])

  const { t } = useTranslation();
  return (
    <div className="address-book-wrapper">
      <div className="address-book-wrapper__top">
        <div className={`address-book-wrapper__title address-book-wrapper__title-${identity}`}>{t('addressBook.address_book')}</div>
        <div className="address-book-wrapper__actions">
          <Input.Search
            name="search"
            placeholder={t('search')}
            onSearch={() => addressBookList(0, search)}
            className="checkouts-header__search-field"
            onChange={e => setSearch(e.target.value)}
            value={search}
            addonAfter={
              <span onClick={resetSearch} className="checkouts-header__reset-button">
                <img src={resetIcon[identity]} alt="Reset" />
              </span>
            }
          />
          <Button onClick={() => setIsOpenModal(true)} type="primary">{t('addressBook.add_new_account')}</Button>
        </div>
      </div>
      <AddressBookList
        setUser={setUser}
        addressBookList={addressBookList}
        addressBook={addressBook}
        deleteAddressBook={deleteAddressBook}
      />

      {addressBook?.pages > 1 && (
        <ReactPaginate
          pageCount={addressBook?.pages}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={addressBookList}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={"«"}
          nextLabel={"»"}
          breakLabel={"..."}
          forcePage={addressBook?.page - 1}
        />
      )}

      <AddAddressModal
        currencies={currencies}
        typeNetwork={typeNetwork}
        visible={isOpenModal}
        close={() => setIsOpenModal(false)}
        createAddressBook={createAddressBook}
        addressBookList={addressBookList}
        user={user}
        setUser={setUser}
        changeAddressBook={changeAddressBook}
        notificationsChangeError={notificationsChangeError}
      />
    </div>
  )
};

const mapStateToProps = state => ({
  typeNetwork: state.networkFilter,
  addressBook: state.transactions.addressBookList,
  currencies: state.currencies.data,
  notificationsChangeError:  state.transactions.notificationsChangeError
});

const mapDispatchToProps = {
  getAddressBookList,
  createAddressBook,
  deleteAddressBook,
  changeAddressBook
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressBookWrapper);